"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../../identity");

var RadioButton = function RadioButton(_a) {
  var label = _a.label,
      value = _a.value,
      _onChange = _a.onChange,
      checked = _a.checked,
      disabled = _a.disabled,
      _b = _a.theme,
      theme = _b === void 0 ? identity_1.ThemeLight : _b;
  return react_1["default"].createElement("div", {
    className: "mt-4"
  }, react_1["default"].createElement("div", {
    className: "flex items-center"
  }, react_1["default"].createElement("input", {
    id: value,
    value: value,
    type: "radio",
    checked: checked,
    disabled: disabled,
    onChange: function onChange(_a) {
      var checked = _a.target.checked;
      return _onChange(checked);
    },
    className: "form-radio h-4 w-4 " + (theme ? theme.form.textColor : "text-gray-800") + " transition duration-150 ease-in-out"
  }), react_1["default"].createElement("label", {
    htmlFor: value,
    className: "ml-3"
  }, react_1["default"].createElement("span", {
    className: "block text-sm leading-5 font-medium " + (theme ? theme.form.textColor : "text-gray-800")
  }, label))));
};

exports.RadioButton = RadioButton;